module.exports = __webpack_public_path__ + "img/mbupload.5eda31f4.svg";